import { useMutation } from 'react-query';
import { checkoutService } from 'services';
import { VerifyRewardPointParams } from 'types';

export const useVerifyRewardPoints = () => {
  return useMutation(({ shipAddressId }: VerifyRewardPointParams) => {
    return checkoutService.verifyRewardPoints(shipAddressId);
  });
};
